import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onClick", "title", "className", "disabled", "buttonText", "children"];
var _dec, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import s from './Button.scss';
var ToolbarBtn = (_dec = withStyles(s), _dec(_class = (_class2 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ToolbarBtn, _React$PureComponent);
  var _super = _createSuper(ToolbarBtn);
  function ToolbarBtn() {
    _classCallCheck(this, ToolbarBtn);
    return _super.apply(this, arguments);
  }
  _createClass(ToolbarBtn, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onClick = _this$props.onClick,
        title = _this$props.title,
        className = _this$props.className,
        disabled = _this$props.disabled,
        buttonText = _this$props.buttonText,
        children = _this$props.children,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Button, _extends({
        "data-test-id": "YXmb8A1fK6ZYKFnRRGN6d",
        variant: "outlined",
        className: classNames(s.btn, className, _defineProperty({}, s.disabled, disabled)),
        onClick: onClick,
        disabled: disabled
      }, rest), title && /*#__PURE__*/React.createElement(FormattedMessage, title), !title && buttonText, children);
    }
  }]);
  return ToolbarBtn;
}(React.PureComponent), _defineProperty(_class2, "defaultProps", {
  className: '',
  disabled: false,
  buttonText: '',
  title: '',
  children: null
}), _class2)) || _class);
export { ToolbarBtn as default };